import React from "react";
import { Button, Modal } from "antd";
import { FONT_SIZE_PX } from "config/theme/constants";

interface IAddActionModal {
  title: string;
  isModalOpen: boolean;
  handleOk: () => void;
  handleCancel: () => void;
  cancelText: string;
  saveText: string;
  children: React.ReactNode;
  pending: boolean;
  className: string;
  formName: string;
  width?: string;
  isClose?: boolean;
  isFooter?: boolean;
}

const AddActionModal = ({
  title,
  isModalOpen,
  handleOk,
  handleCancel,
  cancelText,
  saveText,
  children,
  pending,
  className,
  formName,
  width,
  isClose,
  isFooter = true,
}: IAddActionModal) => {
  return (
    <Modal
      title={title}
      open={isModalOpen}
      className={className}
      onOk={handleOk}
      onCancel={handleCancel}
      width={width ? width : "520px"}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      footer={[
        isFooter && isClose ? (
          <>
            <Button
              key="back"
              type="primary"
              onClick={handleCancel}
              style={{
                fontSize: FONT_SIZE_PX.xs,
                marginRight: 23,
                minWidth: 100,
              }}
            >
              Close
            </Button>
          </>
        ) : (
          isFooter && (
            <>
              <Button
                key="submit"
                type="primary"
                loading={pending}
                htmlType="submit"
                form={formName}
                style={{ fontSize: FONT_SIZE_PX.xs, minWidth: 100 }}
              >
                {saveText}
              </Button>
              <Button
                key="back"
                type="primary"
                onClick={handleCancel}
                style={{
                  fontSize: FONT_SIZE_PX.xs,
                  marginRight: 23,
                  minWidth: 100,
                }}
              >
                {cancelText}
              </Button>
            </>
          )
        ),
      ]}
      maskClosable={false}
    >
      {children}
    </Modal>
  );
};

export default AddActionModal;
